export default "__VITE_ASSET__BCq6wvC4__"